import * as React from "react";
const SvgFiRrClip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clip_svg__a)">
      <path
        fill="#062147"
        d="M22.95 9.6a1 1 0 0 0-1.414 0L10.644 20.539a4.999 4.999 0 0 1-8.536-3.535 5 5 0 0 1 1.464-3.536L14.121 2.876a3 3 0 0 1 4.243 4.242L7.815 17.71a1.02 1.02 0 0 1-1.414 0 1 1 0 0 1 0-1.414l9.392-9.435a1 1 0 0 0-1.414-1.414l-9.392 9.435a3 3 0 0 0 0 4.243 3.073 3.073 0 0 0 4.243 0L19.778 8.532a5 5 0 0 0-7.071-7.07L2.158 12.054a7 7 0 0 0 9.9 9.9L22.95 11.018a1 1 0 0 0 0-1.418"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clip_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClip;
